import styled, {keyframes} from 'styled-components';
import media from '../theme/media';

export const Icon = styled.img`
  display: inline-block;
  margin: 0 .5rem .5rem 0;
  vertical-align: middle;
  width: 48px;
  box-shadow: none !important;
`;

export const IconSmall = styled.img`
  display: inline-block;
  margin-left: .25rem;
  vertical-align: bottom;
  width: 16px;
`;

export const ImgGrid = styled.div`
    display: inline-block;
    width: 25%;
    img {
      max-width: 264px;
    }
    &:nth-child(1) {
      margin-bottom: 5rem;
      ${media.phone`
        margin-bottom: 4rem;
      `}
    }
    ${media.phone`
      width: 50%;
      margin-bottom: 4rem;
    `}
`;

export const ImgBorder = styled.img`
  border: 2px solid #E5E7EA;
  border-radius: 8px;
`;

export const ImgContainer = styled.div`
  position: relative;
  img { vertical-align: top}
`;

export const ImgShadow = styled.div`
  border-radius: 8px;
  position: relative;
  box-shadow: 0 15px 35px rgba(50,50,93,.1), 0 0px 15px rgba(0,0,0,.1);
  img { border-radius: 8px; vertical-align: top}
`;

const ImgAnimation = keyframes `
  from, 50% { opacity: 0; }
  51%, to { opacity: 1; }
`;

const ImgAnimationCaption = keyframes `
  from, 50% { opacity: 1; }
  51%, to { opacity: 0; }
`;

export const ImgBefore = styled.div`
  span {
    animation: ${ImgAnimationCaption} 6s infinite;
    position: absolute;
    bottom: -4rem;
    left: 0;
    right: 0;
  }
`;

export const ImgAfter = styled.div`
  animation: ${ImgAnimation} 6s infinite;
  position: absolute;
  right: 0;
  top: 0;
  width: 100%;
  span {
    position: absolute;
    bottom: -4rem;
    left: 0;
    right: 0;
  }
`;

export const ImgOverlayContainer = styled.div `
  position: relative;
  div:nth-child(2),
  div:nth-child(3),
  div:nth-child(4),
  div:nth-child(5),
  div:nth-child(6) {
    position: absolute;
    top: 0;
    right: 0;
    left: 0;
    img {
      box-shadow: none !important;
    }
  }
`;

export const Iframe = styled.iframe `
  width: 148px;
`;



// WEBPACK FOOTER //
// src/theme/assets.js